import { whenNot } from 'platform/shared/health-apps';
import content from '../../locales/en/content.json';
import { isShortFormEligible } from '../../utils/helpers';
import { householdPages } from './householdInformation';
import { insurancePages } from './insuranceInformation';
import { militaryServicePages } from './militaryService';
import { vaBenefitsPages } from './vaBenefits';
import { veteranPages } from './veteranInformation';

export const chapters = {
  veteranInformation: {
    title: content['veteran--chapter-title'],
    pages: veteranPages,
  },
  vaBenefits: {
    title: content['benefits--chapter-title'],
    pages: vaBenefitsPages,
  },
  militaryService: {
    title: content['service--chapter-title'],
    pages: militaryServicePages,
  },
  householdInformation: {
    title: content['household--chapter-title'],
    pages: householdPages,
    depends: whenNot(isShortFormEligible),
  },
  insuranceInformation: {
    title: content['insurance--chapter-title'],
    pages: insurancePages,
  },
};
